import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

import { Eventconfig } from '../../shared/eventconfig';
import { EventconfigStoreService } from '../../shared/eventconfig-store.service';
import { Eventstatus } from '../../shared/eventstatus';
import { LogService } from '../../shared/log.service';
import { QuestionStoreService } from '../../shared/question-store.service';
import { EventsetupStoreService } from '../../shared/eventsetup-store.service';

@Component({
    selector: 'lse-user-ask-question',
    templateUrl: './user-ask-question.component.html',
    styleUrls: ['./user-ask-question.component.css'],
    animations: [
        trigger('inOutAnimation', [
            transition(':enter', [
                style({ height: 0, opacity: 0 }),
                animate('1.5s ease-in', style({ height: 0, opacity: 1 })),
            ]),
            transition(':leave', [
                style({ height: 0, opacity: 1 }),
                animate('1s ease-in', style({ height: 0, opacity: 0 })),
            ]),
        ]),
        trigger('slideInOut', [
            state('in', style({
                overflow: 'hidden',
                height: '*',
            })),
            state('out', style({
                overflow: 'hidden',
                height: '0px',
            })),
            transition('in => out', animate('250ms ease-in-out')),
            transition('out => in', animate('250ms ease-in-out')),
        ]),
    ],
    standalone: false
})
export class UserAskQuestionComponent implements OnInit, OnDestroy {
  form: any = {};
  author: string;
  location: string;
  msgText: string;
  eLang = 'de';
  eLangGlob: any;
  hintText: string;
  eConfig: Eventconfig;
  eStatus: Eventstatus;
  dataIntervalTimer: any;
  showQuestionForm = 'out';
  // Zeichenlimit aus dem Event-Dokument. null = kein Limit (in der CCP deaktiviert
  // oder noch nicht geladen) — dann ohne maxlength und ohne Zähler.
  charLimit: number | null = null;
  charLimitTimer: any;

  showHint = false;
  showHintTimeout: any;

  errorMessage = 'An error has ocurred';

  eventLanguages: string[] = [];

  constructor(
    private qs: QuestionStoreService,
    private es: EventconfigStoreService,
    private logger: LogService,
    private ep: EventsetupStoreService
  ) {}

  ngOnInit(): void {
    this.eventLanguages = this.ep.getStoredSetup().lang
    this.eLang = this.es.getActiveLang();
    this.eLangGlob = this.es.getLangGlobals();
    this.logger.log('Glob: ' + this.eLangGlob.translateSendBtn);
    this.dataInterval();
    this.dataIntervalTimer = setInterval(() => {
      this.dataInterval();
    }, 1000);
    // Gleicher Rhythmus wie das Status-Polling der Home-Komponente, damit eine
    // Limit-Änderung aus der CCP auch während des Events zügig ankommt.
    this.loadCharLimit();
    this.charLimitTimer = setInterval(() => {
      this.loadCharLimit();
    }, 10000);
  }

  ngOnDestroy(): void {
    clearInterval(this.dataIntervalTimer);
    clearInterval(this.charLimitTimer);
  }

  private loadCharLimit() {
    this.qs.getQuestionsConfig().subscribe(
      (data) => {
        if (data && data.charLimit === null) {
          this.charLimit = null;
        } else if (data && Number.isInteger(data.charLimit) && data.charLimit > 0) {
          this.charLimit = data.charLimit;
        }
      },
      (err) => {
        this.logger.log('Zeichenlimit konnte nicht geladen werden');
      }
    );
  }
  dataInterval() {
    this.eConfig = this.es.getStoredConfig();
    this.eStatus = this.es.getStoredStatus();
    if (this.eStatus.name === undefined) {
      this.eStatus.name = true;
    }
    if (this.eConfig.txtAdditional !== undefined) {
      this.eLangGlob.translateAdditionalLabel = this.eConfig.txtAdditional;
      if(this.eConfig.customPolicyAdditional_enabled !== false) {
        this.eLangGlob.translatePolicyAdditional = this.eConfig.policyAdditional;
      }
    }
    if (this.eConfig.txtName !== undefined) {
      this.eLangGlob.translateNameLabel = this.eConfig.txtName;
      if(this.eConfig.customPolicyName_enabled !== false) {
        this.eLangGlob.translatePolicyName = this.eConfig.policyName;
      }
    }
    if (this.eConfig.txtMessage !== undefined) {
      this.eLangGlob.translateMsgLabel = this.eConfig.txtMessage;
      if(this.eConfig.customPolicyMessage_enabled !== false) {
      this.eLangGlob.translatePolicyMessage = this.eConfig.policyMessage;
      }
    }
  }
  onSubmit() {
    this.logger.log('Execute ' + this.form.msgText);
    if (
      this.form.msgText !== '' &&
      this.form.msgText !== undefined &&
      (this.charLimit === null || this.form.msgText.length <= this.charLimit)
    ) {
      this.hintText = this.eLangGlob.translateqSuccess;
      this.showHint = true;
      this.showHintTimeout = setTimeout(() => {
        this.removeHint();
        this.form.msgText = '';
      }, 3000);

      this.qs.sendMsgNew(this.form,this.eventLanguages, this.eStatus.user_see_questions).subscribe(
        (data) => {
          this.logger.log('Frage an neues System geschickt');
        },
        (err) => {
          this.errorMessage = err.error.message;
        }
      );
    } else {
      this.hintText = this.eLangGlob.translateqError;
      this.showHint = true;
      this.showHintTimeout = setTimeout(() => {
        this.removeHint();
        this.form.msgText = '';
      }, 3000);
    }
  }
  private removeHint() {
    this.showHint = false;
  }
  toggleUserQuestions() {
    this.showQuestionForm = this.showQuestionForm === 'out' ? 'in' : 'out';
  }
}
